import {msg, str} from '@lit/localize';
import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {openDialog} from '../../slices/statusSlice';
import {selectSubscribedPlan} from '../../selectors';
import {cancelSubscription} from '../../slices/planSlice';
import store from '../../store';

@customElement('arc-cancel-subscription-button')
export class CancelSubscriptionButton extends connect(store)(LitElement) {

	static properties = {
		loading: {type: String},
		subscribedPlan: {type: Object},
	};

	constructor() {
		super();
		this.loading = '';
		this.subscribedPlan = null;
	}

	stateChanged(state) {
		this.loading = state.plan.loading;
		this.subscribedPlan = selectSubscribedPlan(state);
	}

	async onCancelSubscription() {
		const dialogOptions = {
			title: msg('Are you sure?'),
			message: msg(str`You are about to cancel your subscription.`),
			labelConfirm: msg('OK'),
			labelCancel: msg('Cancel'),
		};
		const handleConfirm = async () => {
			await store.dispatch(cancelSubscription());
			window.removeEventListener('confirm', handleConfirm);
		};
		window.addEventListener('confirm', handleConfirm);
		store.dispatch(openDialog(dialogOptions));
	}

	render() {
		const canShow = this.subscribedPlan &&
			!this.subscribedPlan.free && !this.subscribedPlan.scheduledToCancelAt;
		return canShow && html`
			<arc-button
				@click=${() => this.onCancelSubscription()}
				title="${msg('Cancel my Subscription')}"
				type="secondary"
				?disabled="${this.loading === 'cancelSubscription'}"
			></arc-button>
		`;
	}
}
